import { Flex, Heading, BodyText } from '@utilitywarehouse/hearth-react';
import { space } from '@utilitywarehouse/hearth-tokens/js';

import Layout from '~/components/Layout';
import InnerContainer from '~/components/Layout/InnerContainer';
import { usePageTracking } from '~/hooks/usePageTracking';

const NotFoundPage = () => {
  usePageTracking('Organic / Not found page');

  return (
    <Layout>
      <Flex
        direction="column"
        justifyContent="center"
        alignItems="center"
        style={{
          flex: 1,
        }}
      >
        <InnerContainer
          maxWidth={650}
          style={{
            textAlign: 'center',
            paddingTop: space[400],
            paddingBottom: space[400],
          }}
        >
          <Heading as="h1" size="xl" marginBottom="200">
            This isn&apos;t the page you&apos;re looking for
          </Heading>
          <BodyText>
            We couldn&apos;t find that address right now. Please check that
            it&apos;s entered correctly, or try again in a little while.
          </BodyText>
        </InnerContainer>
      </Flex>
    </Layout>
  );
};

export default NotFoundPage;
